<template>
  <transition name="modal-fade">
    <div class="confirm modal is-active" v-if="isActive">
      <div class="modal-background"></div>
      <div class="modal-content box" :style="styleObject">
        <v-runtime-template v-if="options.isTemplate" :template="options.message"></v-runtime-template>
        <div v-else class="confirm-body" v-html="options.message"></div>
        <div class="confirm-buttons" @click="defaultClick">
          <button v-for="(button, idx) in options.buttons" :key="idx" class="button" :class="button.class" @click="handleClick(button.action)">{{button.name}}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import VRuntimeTemplate from 'v-runtime-template'

export default {
  name: 'confirmModal',
  data () {
    return {
      defaults: {
        message: '',
        closeByDefault: true,
        minWidth: '300',
        maxWidth: '400',
        componentTemplate: false,
        buttons: [],
        isTemplate: false,
        events: {}
      },
      isActive: false
    }
  },
  components: {
    VRuntimeTemplate
  },
  computed: {
    options () {
      return {
        ...this.defaults,
        ...this.$options.options
      }
    },
    styleObject () {
      return {
        minWidth: this.options.minWidth + 'px',
        maxWidth: this.options.maxWidth + 'px'
      }
    }
  },
  methods: {
    close () {
      var self = this
      if (typeof self.options.onClose === 'function') {
        self.options.onClose()
      }
      self.isActive = false

      // completely delete this element after the fade out animation
      setTimeout(function () {
        self.$destroy()
        self.$el.parentNode.removeChild(self.$el)
      }, 200)
    },
    emitEvent (e, emit) {
      var self = this
      if (typeof self.options.events[emit] === 'function') {
        self.options.events[emit](e)
      }
    },
    handleClick (cb) {
      if (typeof cb === 'function') { cb() }
    },
    defaultClick (e) {
      if (this.options.closeByDefault && ['BUTTON', 'INPUT', 'A'].indexOf(e.target.nodeName) !== -1) { this.close() }
    }
  },
  beforeMount () {
    var self = this
    if (typeof window !== 'undefined') {
      self.$nextTick(() => {
        document.body.appendChild(self.$el)
      })
    }
  },
  mounted () {
    this.isActive = true
  }
}
</script>

<style lang="scss" scoped>

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .2s;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal {
  z-index: 1012;
  .modal-content {
    color: $grey-darker;
    width: auto;
    min-width: 300px;
    max-width: 400px;

    .confirm-body{
      // margin-bottom: 1.25rem;
    }
    .confirm-buttons{
      margin-top: 1.25rem;
      button + button{
        margin-left: 10px;
      }
    }
  }
}
</style>
